
/** 
 * The point at which the user exited the Link flow. 
 * See https://plaid.com/docs/link/web/#onexit
 * 
 * Note that "UnknownStatus" is used when the status is not recognized or not provided.
 * Added in the case a future Plaid update introduces new statuses that are not yet handled or removes existing ones.
 */
export type PlaidLinkExitActionStatus =
    | "RequiresQuestions"
    | "RequiresSelections"
    | "RequiresCode"
    | "ChooseDevice"
    | "RequiresCredentials"
    | "RequiresAccountSelection"
    | "RequiresOAuth"
    | "InstitutionNotFound"
    | "InstitutionNotSupported"
    | "UnknownStatus";

    
/**
 * Maps Plaid API's snake_case statuses to internal PlaidLinkExitActionStatus values.
 */
const PLAID_STATUS_MAP: Record<string, PlaidLinkExitActionStatus> = {
    requires_questions: "RequiresQuestions",
    requires_selections: "RequiresSelections",
    requires_code: "RequiresCode",
    choose_device: "ChooseDevice",
    requires_credentials: "RequiresCredentials",
    requires_account_selection: "RequiresAccountSelection",
    requires_oauth: "RequiresOAuth",
    institution_not_found: "InstitutionNotFound",
    institution_not_supported: "InstitutionNotSupported"
};


/**
 * Attempts to parse a raw status string from Plaid into a PlaidLinkExitActionStatus.
 * @param raw - The raw status string to parse.
 * @returns The mapped PlaidLinkExitActionStatus, or "UnknownStatus" if unrecognized.
 */
export function parsePlaidLinkExitActionStatus(raw: string): PlaidLinkExitActionStatus {
    return PLAID_STATUS_MAP[raw] ?? "UnknownStatus";
}
